import { Icon } from "@/components/Icon/Icon";
import type { SubstanceUsage } from "./_model";
import type { SubstanceRow } from "./_model";
import { UsageTag } from "./atoms/UsageTag";

interface SubstanceUsageTabsProps {
  items: SubstanceRow[];
  value: "all" | SubstanceUsage;
  onChange: (v: "all" | SubstanceUsage) => void;
}

const TABS: { id: "all" | SubstanceUsage; label: string; icon: string }[] = [
  { id: "all", label: "All substances", icon: "molecule" },
  { id: "ingredient", label: "Ingredients", icon: "box" },
  { id: "target", label: "Targets", icon: "target" },
  { id: "formulation", label: "Formulations", icon: "beaker" },
];

export function SubstanceUsageTabs({ items, value, onChange }: SubstanceUsageTabsProps) {
  const countFor = (id: "all" | SubstanceUsage) =>
    id === "all" ? items.length : items.filter((s) => s.usage.includes(id as SubstanceUsage)).length;

  return (
    <div className="hstack" style={{ gap: 4 }}>
      {TABS.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              padding: "7px 13px 7px 11px", borderRadius: 8,
              background: active ? "var(--panel)" : "transparent",
              border: `1px solid ${active ? "var(--line-strong)" : "transparent"}`,
              boxShadow: active ? "var(--shadow-1)" : "none",
              color: active ? "var(--ink)" : "var(--ink-3)",
              cursor: "pointer", transition: "background 120ms, border-color 120ms",
            }}
            onMouseEnter={(e) => { if (!active) e.currentTarget.style.background = "var(--bg-sunk)"; }}
            onMouseLeave={(e) => { if (!active) e.currentTarget.style.background = "transparent"; }}
          >
            <span style={{ display: "inline-flex" }}>
              {active
                ? (t.id === "all"
                    ? (
                      <span style={{
                        width: 20, height: 20, borderRadius: 4, display: "inline-flex",
                        alignItems: "center", justifyContent: "center",
                        background: "var(--accent-soft)", color: "var(--accent-ink)",
                        border: "1px solid var(--accent-line)",
                      }}>
                        <Icon name="molecule" size={12} />
                      </span>
                    )
                    : <UsageTag id={t.id as SubstanceUsage} iconOnly />
                  )
                : (
                  <span style={{ display: "inline-flex", color: "var(--ink-4)" }}>
                    <Icon name={t.icon as Parameters<typeof Icon>[0]["name"]} size={14} />
                  </span>
                )}
            </span>
            <span style={{ fontSize: 13, fontWeight: active ? 600 : 500 }}>{t.label}</span>
            <span className="mono" style={{
              fontSize: 11, fontWeight: 600, letterSpacing: 0,
              padding: "1px 6px", borderRadius: 999,
              background: active ? "var(--accent-soft)" : "var(--bg-sunk)",
              color: active ? "var(--accent-ink)" : "var(--ink-4)",
            }}>{countFor(t.id)}</span>
          </button>
        );
      })}
    </div>
  );
}
